import { Injectable, inject } from '@angular/core';

import { NavigationService, PageViewDataProvider, TrackingData } from '@frontend/vanilla/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class PaymentsPageViewDataProvider implements PageViewDataProvider {
    private navigationService = inject(NavigationService);

    pageSource?: string;

    paymentsPathPageSource: { [key: string]: string } = {
        'payments/deposit/paymentName': 'deposit input page',
        'payments/withdrawal/withdrawal-success': 'withdrawal success page',
        'payments/deposit/deposit-success': 'deposit success page',
        'payments/deposit/deposit-declined': 'deposit declined page',
        'payments/options': 'deposit options page',
        'payments/deposit': 'deposit page',
        'payments/withdrawal': 'withdrawal page',
        'payments': 'cashier',
    };

    getData(): Observable<TrackingData> {
        const path = this.navigationService.location.pathname;
        if (path.includes('payments')) {
            for (const pagePath of Object.keys(this.paymentsPathPageSource)) {
                if (path.includes(pagePath)) {
                    this.pageSource = this.paymentsPathPageSource[pagePath];
                    if (path.includes('payments/deposit/paymentName')) {
                        this.pageSource = this.pageSource + ' ' + (path.split('/').filter(Boolean).pop() ?? '');
                    }
                    break;
                } else {
                    this.pageSource = 'cashier';
                }
            }
            let data: Record<string, string> = {
                'page.source': this.pageSource ?? 'cashier',
            };
            return of(data);
        }
        let data: Record<string, string> = {};
        return of(data);
    }
}
